import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  deleteLocationReview,
  openLightbox,
  selectReviewsWithPhotos,
} from '../../redux/locationSlice'
import { setReviewData } from '../../redux/reviewSlice'
import { useAppHistory } from '../../utils/useAppHistory'
import { useIsDesktop } from '../../utils/useBreakpoint'
import Review from './Review'
import { ReviewButton } from './ReviewButton'

const EntryReviews = () => {
  const isDesktop = useIsDesktop()
  const history = useAppHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const user = useSelector((state) => state.auth.user)
  const reviews = useSelector((state) => state.location.reviews)

  const reviewsWithPhotos = useSelector(selectReviewsWithPhotos)

  const onImageClick = (reviewIndex, photoIndex) => {
    dispatch(openLightbox({ reviewIndex, photoIndex }))
  }
  return (
    <>
      {!isDesktop && <ReviewButton />}
      <h3>{t('glossary.review.other')}</h3>
      <div style={{ paddingBottom: 'var(--safe-area-inset-bottom, 0px)' }}>
        {reviews.map((review) => {
          const onReviewImageClick = (imageIndex) =>
            onImageClick(
              reviewsWithPhotos.findIndex((r) => r.id === review.id),
              imageIndex,
            )
          if (review.user_id === user?.id) {
            return (
              <Review
                key={review.id}
                review={review}
                onImageClick={onReviewImageClick}
                onEditClick={() => {
                  dispatch(setReviewData(review))
                  history.push(`/reviews/${review.id}/edit`)
                }}
                onDeleteClick={() => dispatch(deleteLocationReview(review.id))}
                editable
              />
            )
          } else {
            return (
              <Review
                key={review.id}
                review={review}
                onImageClick={onReviewImageClick}
              />
            )
          }
        })}
      </div>
    </>
  )
}

export default EntryReviews
